module.exports = __webpack_public_path__ + "static/img/tecladoMatricial-1.d26c89a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tecladoMatricial-1.svg
// module id = c07r
// module chunks = 0